import { Injectable } from "@angular/core";

@Injectable()
export class ProtocolloResponse {
    data: string = "";
    esito: string = "";
    messaggio: string = "";
    numeroProtocollo: string = "";
}